import { useLayoutEffect, useState } from "react";
import SideNavLayout from "@/layouts/SideNavLayout";
import AchievementModals from "@/components/modals/livewire/AchievementModals";
import AchievementDashboard from "@/components/dashboards/AchievementDashboard";
import DailyAnalystOverView from "@/components/dashboards/DailyAnalystOverview";
import WeeklyAnalystOverView from "@/components/dashboards/WeeklyAnalystOverview";
import OperationsDashboard from "@/components/dashboards/OperationsDashboard";
import LeaderDashboard from "@/components/dashboards/LeaderDashboard";

import useFullScreen from "@/hooks/useFullScreen";
import "@/styles/scss/_livewire.scss";
import { useLiveWire } from "@/hooks/useLiveWire";


const Slides = [
  // { duration: 5000, component: WeeklyAnalystOverView },
  { duration: 5000, component: DailyAnalystOverView },
  // { duration: 5000, component: LeaderDashboard },
  // { duration: 5000, component: AchievementDashboard },
  // { duration: 5000, component: OperationsDashboard },
];

function LiveWirePage() {
  const { initialized } = useLiveWire({ refreshInterval: 60000 });
  const isFullScreen = useFullScreen();
  const [activeSlide, setActiveSlide] = useState(0);

  useLayoutEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % Slides.length);
    }, Slides[activeSlide].duration);
    return () => clearInterval(interval);
  });

  const CurrentComponent = Slides[activeSlide].component;

  if (!initialized) return (
    <div className="text-center h-100 w-100 mt-5">
      <span className="spinner-border text-orange">
        <span className="visually-hidden">Loading...</span>
      </span>
    </div>
  );

  return (
    <SideNavLayout fullScreen={isFullScreen}>
      <div className="p-2">
        {/* <LiveWireHeader /> */}
        <CurrentComponent />
        <AchievementModals />
      </div>
    </SideNavLayout>
  );
}

const LiveWireHeader = () => {
  return (
    <div className="p-2 mb-1">
      <img alt="logo" height="30" src={"/logo-icon-only.png"} />
    </div>
  );
};

export default LiveWirePage;
